import { Routes } from '@angular/router';
import { OttExpiredComponent } from './templates/common/ott-expired/ott-expired.component';

export const routes: Routes = [
    { path: 'ott-expired', component: OttExpiredComponent },
    {
        path: 'mcs-c2p',
        loadChildren: () => import('./templates/mcs-c2p/mcs-c2p.module').then(m => m.McsC2pModule)
    },
    {
        path: 'scof-sdk',
        loadChildren: () => import('./templates/scof-sdk/scof-sdk.module').then(m => m.ScofSdkModule)
    },
    {
        path: 'scof-b2b',
        loadChildren: () => import('./templates/scof-b2b/scof-b2b.module').then(m => m.ScofB2bModule)
    },
    {path: '', redirectTo: 'mcs-c2p', pathMatch: 'full'},
];
